import React from "react";

/**
 * Top-of-page promo marquee. Smooth horizontal loop using CSS keyframes.
 * Messages list is duplicated once so the loop appears seamless.
 *
 * Props:
 *   messages : string[]  rotating items
 *   speed    : number    sweep duration in seconds (lower = faster)
 *   bg, fg   : colors
 *   testId   : data-testid for the wrapping element
 */
const MarqueeBar = ({ messages = [], speed = 25, bg = "#3D3140", fg = "#FBF7F4", testId = "promo-marquee" }) => {
  if (!messages.length) return null;
  const dur = `${Math.max(8, Math.min(120, speed))}s`;
  // Duplicate the list so the keyframe loop has no visible jump
  const loop = [...messages, ...messages];
  return (
    <div
      className="w-full overflow-hidden font-label text-[11px] tracking-[0.28em] uppercase"
      style={{ background: bg, color: fg }}
      data-testid={testId}
      role="region"
      aria-label="Site announcements"
    >
      <div
        className="flex whitespace-nowrap py-2"
        style={{ animation: `rieave-marquee ${dur} linear infinite`, willChange: "transform" }}
      >
        {loop.map((m, i) => (
          <span key={i} className="px-8 inline-flex items-center gap-3 shrink-0">
            <span aria-hidden style={{ opacity: 0.55 }}>✦</span>
            <span>{m}</span>
          </span>
        ))}
      </div>
      <style>{`
        @keyframes rieave-marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="${testId}"] > div { animation: none !important; transform: none !important; justify-content: center; }
        }
      `}</style>
    </div>
  );
};

export default MarqueeBar;
